import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { GDriveIcon } from 'assets/icons';
import AccountLogo from 'components/Account-Logo';

const GuidelineHeader = ({ accountId, userStatus }) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const firebaseHelper = getFirebaseBackend();
  const [gDriveLink, setGDriveLink] = useState('');

  const canOpenDrive = () =>
    ['Super Admin', 'Admin', 'Client Admin', 'Client'].includes(userStatus);

  const canCreateContent = () => userStatus === 'Super Admin';

  useEffect(() => {
    const fetchDriveLink = async () => {
      const account = await firebaseHelper.getAccount(accountId);
      if (account?.gDriveFolders?.content?.delivery) {
        setGDriveLink(account.gDriveFolders.content.delivery);
      }
    };
    if (accountId) fetchDriveLink();
  }, [accountId]);

  return (
    <HeaderLayout>
      <div className="header-top m-0 p-4">
        <div className="task-summary-photo">
          <AccountLogo accountId={accountId} />
        </div>

        <div className="header-actions">
          {canOpenDrive() && (
            <Button className="btn-drive" onClick={() => window.open(gDriveLink, '_blank')}>
              <GDriveIcon />
              {`${translate('Open')} Drive`}
            </Button>
          )}

          {canCreateContent() && (
            <Button className="btn-guideline-create" onClick={() => navigate('/create-guideline')}>
              {translate('Create Content')}
            </Button>
          )}
        </div>
      </div>
    </HeaderLayout>
  );
};

const HeaderLayout = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  .task-summary-photo {
    height: 3rem;
  }

  .task-summary-logo {
    height: 3rem !important;
    width: 3rem !important;
    margin-left: 0 !important;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
  }

  .header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .header-logo {
    display: flex;
    align-items: center;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  button {
    height: 2.75rem;
    width: fit-content;
    padding: 0.625rem 1rem !important;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    border-radius: 4px;
    font-size: 0.8125rem;
    line-height: normal;
    font-weight: 500;
  }

  .btn-drive {
    min-width: 8.5rem;
    border: 1px solid #e2e8f0;
    background-color: transparent;
    color: #2d3748 !important;
  }

  .btn-drive:hover {
    border: 1px solid #e2e8f0;
    background-color: #f7fafc;
  }

  .btn-guideline-create {
    border: none;
    background-color: #556ee6;
    color: #fff;
  }

  .btn-guideline-create:hover {
    background-color: #3b5bfc;
  }
`;

GuidelineHeader.propTypes = {
  accountId: PropTypes.string,
  userStatus: PropTypes.string,
};

export default GuidelineHeader;
